import { useRef, useState } from "react";
import { motion } from "framer-motion";

/**
 * MagneticButton — subtle cursor-follow (premium micro-interaction).
 * Disables on touch / reduced-motion devices automatically.
 */
export default function MagneticButton({ children, className = "", strength = 0.25, ...rest }) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const onMove = (e) => {
    if (window.matchMedia?.("(pointer: coarse)").matches) return;
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left - r.width / 2) * strength;
    const y = (e.clientY - r.top - r.height / 2) * strength;
    setPos({ x, y });
  };
  const onLeave = () => setPos({ x: 0, y: 0 });

  return (
    <motion.button
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 200, damping: 20, mass: 0.4 }}
      className={className}
      {...rest}
    >
      <motion.span
        animate={{ x: pos.x * 0.4, y: pos.y * 0.4 }}
        transition={{ type: "spring", stiffness: 200, damping: 20, mass: 0.4 }}
        className="inline-flex items-center"
      >
        {children}
      </motion.span>
    </motion.button>
  );
}
